import "./App.css";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Ytvidoe from "./components/videoplayer/VideoPlayer";
import Profile from "./components/profile/profile";
import Userlist from "./components/userlist/userlist";
import UserProfile from "./components/userlist/UserProfile"; // ✅ Add this import
import AddonStatus from "./components/addonstatus/addonstatus";
import Vortexdownload from "./components/vortex-download/vortex-download";
import Settings from "./components/profile/settings";
import InstallPrompt from "./components/InstallPrompt";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";


import About from "./pages/About";
import Games from "./pages/Games";
import Contact from "./pages/Contact";
import Login from "./pages/login";

import Dashboard from "./pages/dashboard";

import Faq from "./pages/faq";
import Services from "./pages/tos";
import Privacy from "./pages/privacy";
import Announcements from "./pages/forums";
import CreatePost from "./pages/create";
import ViewPost from "./pages/ViewPost";
import VotePage from "./pages/vote";
import EditPage from "./pages/edit"; // Import the edit page
import VortexnetworkStudios from "./pages/vortexnetworkStudios";

import { AuthProvider, useAuth } from "./components/context/AuthContext"; // ✅ Auth

// 🔒 Protect routes if not logged in
const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};



// function getDeviceType() {
//     const ua = navigator.userAgent;

//     if (/iPad|Android(?!.*Mobile)|Tablet/i.test(ua)) {
//         return "Tablet";
//     }

//     if (/iPhone|Android.*Mobile|Windows Phone/i.test(ua)) {
//         return "Phone";
//     }

//     return "Desktop";
// }
function InstallPromptWrapper() {
  const { user } = useAuth();

  if (!user) return null;

  return <InstallPrompt />;
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

//console.log(getDeviceType());

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <main className="App-content">
            <Routes>
              {/* Public route */}
              <Route path="/login" element={<Login />} />

              {/* Public content routes */}
              <Route path="/" element={<Ytvidoe />} />
              <Route
                element={
                  <PrivateRoute>
                    <InstallPrompt/>
                  </PrivateRoute>
                }
                />
              <Route
                path="/users"
                element={
                  <PrivateRoute>
                    <Userlist />
                  </PrivateRoute>
                }
              />
              <Route
               path="/edit"
               element={
                <PrivateRoute>
                <EditPage/>
               </PrivateRoute>
               }
               />
              <Route path="/vortexnetworkstudios" element={<VortexnetworkStudios />} />
              <Route path="/vote" element={<VotePage />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute>
                    <Settings />
                  </PrivateRoute>
                }
              />        
              <Route
                path="/addonstatus"
                element={
                  <PrivateRoute>
                    <AddonStatus />
                  </PrivateRoute>
                }
              />
              <Route
                path="/addons"
                element={<Vortexdownload />}
              />              
              <Route
                path="/profile/:id" // ✅ route for clicking user in list
                element={
                  <PrivateRoute>
                    <UserProfile />
                  </PrivateRoute>
                }
              />
              <Route path="/forums" element={<Announcements />} />
              <Route path="/create" element={<PrivateRoute><CreatePost /></PrivateRoute>} />
              <Route path="/post/:id" element={<ViewPost />} />
              <Route path="/about" element={<About />} />
              <Route path="/servers" element={<Games />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/services" element={<Services />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/contact" element={<Contact />} />
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />
            </Routes>
          </main>
          <InstallPromptWrapper />
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}


if (navigator.userAgent.includes("VortexDesktop")) {
    console.log("Running inside the Electron app");
} else {
    //console.log("Normal web browser");
}
export default App;
